module.exports = __webpack_public_path__ + "a4d4c8da6c30bf66100d2399c0ef6626.pdf";